import { render, staticRenderFns } from "./ProcessCertificateReanalysisRequestButton.vue?vue&type=template&id=705dce38&scoped=true&"
import script from "./ProcessCertificateReanalysisRequestButton.vue?vue&type=script&lang=js&"
export * from "./ProcessCertificateReanalysisRequestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705dce38",
  null
  
)

export default component.exports